import { PAGE_ROUTES } from "../../managers/RouteManager";
import { TABLES } from "../../managers/TableManger";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import MaskInputUtil from "../../SharedComponents/MaskInput/MaskInputUtil";
import { SETTING_CARD } from "../settings/Settings";

export const MODULE = {
    SALARY: "EMPLOYEE_SALARY",
    CANDIDATE: "CANDIDATE",
    JOB_OPENING: "JOB_OPENING",
    JOB_PIPELINE: "JOB_PIPELINE",
    JOB_FORM: "JOB_FORM",
    EMAIL_TEMPLATE: "EMAIL_TEMPLATE",
    PAY_SCHEDULE: "PAY_SCHEDULE",
    PAYRUN: "PAYRUN",
    PAYSTUB: "PAYSTUB",
    EMPLOYEE: "EMPLOYEE",
    CONTRACTOR: "CONTRACTOR",
    CONTRACTOR_PAYRUN: "CONTRACTOR_PAYRUN",
    EARNINGS_AND_DEDUCTIONS: "EARNINGS_AND_DEDUCTIONS",
    EARNING_DEDUCTION_TEMPLETE: "EARNINGS_AND_DEDUCTIONS_TEMPLATE",
    GIRO: "GIRO",
    COMPENSATORY_OFF: "COMPENSATORY_OFF",
    SHIFT: "SHIFT",
    SHIFT_ASSIGNMENT: "SHIFT_ASSIGNMENT",
    OVERTIME_POLICY: "OVERTIME_POLICY",
    OT_MULTIPLIER: "OT_MULTIPLIER",
    TIMESHEET: "TIMESHEET",
    IT_DECLARATION: "IT_DECLARATION",
    EMPLOYEE_DECLARATION: "EMPLOYEE_DECLARATION",
    POI: "POI",
    EMPLOYEE_POI: "EMPLOYEE_POI",
    EMPLOYEE_APPROVAL: "EMPLOYEE_APPROVAL",
    REPORTS: "REPORTS",
    AUTOMATION: "AUTOMATION",
    COMPANY_SETTINGS: "COMPANY_SETTINGS",
    IMPORT_LOG: "IMPORT_LOG",
    COMP_OFF_CONFIGURATION: "COMPENSATORY_OFF",
    MANAGE_COMP_OFF: "COMPENSATORY_OFF",
    MANAGE_COMP_OFF_REQUEST: "COMPENSATORY_OFF",
    MY_COMP_OFF: "COMPENSATORY_OFF",
    MY_ATTENDANCE: "MY_ATTENDANCE",
    TEAM_ATTENDANCE: "TEAM_ATTENDANCE",
    BENEFITS: "BENEFITS",
    BIO_ATTENDANCE_SETTING: "BIO_ATTENDANCE_SETTING",
    PERFORMANCE_APPRAISAL_CYCLE: "PERFORMANCE_APPRAISAL_CYCLE",
    PERFORMANCE_REVIEW: "PERFORMANCE_REVIEW",
    PERFORMANCE_GOAL: "PERFORMANCE_GOAL",
    EXPENSE_CLAIM: "EXPENSE_CLAIM",
    EXPENSE_ADMIN_SETTING: "EXPENSE_ADMIN_SETTING",
    EXPENSE_INTEGRATION_SETTING: "EXPENSE_INTEGRATION_SETTING",
    TEAM_REPORT: "TEAM_REPORT",
    MANAGE_REQUESTS: "MANAGE_REQUESTS",
    REQUEST_TIME_OFF: "REQUEST_TIME_OFF",
    TIME_OFF_REPORT: "TIME_OFF_REPORT",
    TIME_OFF_POLICY: "TIME_OFF_POLICY",
    TIME_OFF_ADJUSTMENT: "TIME_OFF_ADJUSTMENT",
    COMPANY_HOLIDAYS: "COMPANY_HOLIDAYS",
    TIME_OFF_USER_MANAGEMENT: "TIME_OFF_USER_MANAGEMENT",
    TIME_OFF_COMPANY_SETTINGS: "TIME_OFF_COMPANY_SETTINGS",
    POLICY_AND_RESOURCES: "POLICY_AND_RESOURCES",
    IMPORT_LOG: "IMPORT_LOG"
}

export const ACTION = {
    VIEW: "VIEW",
    CREATE: "CREATE",
    EDIT: "EDIT",
    DELETE: "DELETE",
    IMPORT: "IMPORT",
    EXPORT: "EXPORT",
    DRAFT: "DRAFT",
    SUBMIT: "SUBMIT",
    RESET: "RESET",
    APPROVE: "APPROVE",
    REJECT: "REJECT",
    PRINT: "PRINT",
    SYNC: "SYNC",
    REVERT: "REVERT"
}

export const TABLE_MODULE_MAP = {
    [TABLES.CANDIDATE]: MODULE.CANDIDATE,
    [TABLES.JOB_PIPELINE]: MODULE.JOB_PIPELINE,
    [TABLES.JOB_FORMS]: MODULE.JOB_FORM
}

export const EXCLUDE_MODULES = [""];

class PermissionUtils {
    static USER_ROLE = null;
    static ROLE_PERMISSION = null;

    static setUserRole(role) {
        PermissionUtils.USER_ROLE = role;
    }

    static isDefaultRoleAssigned() {
        return PermissionUtils.USER_ROLE?.isDefault || false;
    }

    static getLoggedInUserRoleKey() {
        if (PermissionUtils.USER_ROLE?.isDefault) {
            switch (PermissionUtils.USER_ROLE?.name) {
                case "ADMIN":
                    if (TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED)) {
                        return "sys_admin";
                    }
                    return PermissionUtils.USER_ROLE.name.toLowerCase();
                default:
                    return PermissionUtils.USER_ROLE.name.toLowerCase();
            }
        } else if (PermissionUtils.USER_ROLE?.isSystemRole) {
            return PermissionUtils.USER_ROLE.key;
        }

        return null;
    }

    static hasMultiModuleAccess(modules, action, hasEachAccess) {
        if(hasEachAccess && modules && Array.isArray(modules)) {
            // hasMultiModuleAccess : multi access with AND condition
            const noAccessModuleIndex = modules.findIndex(m=>!PermissionUtils.hasAccess(m, action))
            return noAccessModuleIndex === -1
        } else 
        if (modules && Array.isArray(modules)) {
            return modules.find(m=>PermissionUtils.hasAccess(m, action)) 
        } else {
            return PermissionUtils.hasAccess(modules, action)
        }
    }

    static hasAccess(module, action) {
        if (TenantService.get(TENANT.IS_HIRING_ADMIN) || TenantService.get(TENANT.IS_OWNER)) {
            return true;
        }

        if (TenantService.get(TENANT.IS_ADMIN) && PermissionUtils.USER_ROLE?.isDefault) {
            return true;
        }

        const m = PermissionUtils.USER_ROLE?.modules?.find((m) => m.key === module);
        if (Array.isArray(m?.permissions)) {
            let hasAccess = false;
            if (Array.isArray(action)) {
                action.forEach((a) => {
                    if (m.permissions.includes(a)) {
                        hasAccess = true;
                    }
                })
            } else {
                hasAccess = m.permissions.includes(action);
            }

            return hasAccess;
        }

        return false;
    }

    static showMaskedAmount(amount, selfView) {
        if (selfView) {
            return amount;
        } else if (typeof amount === "string" && !amount?.includes('-1.00') && (!TenantService.get(TENANT.IS_ADMIN) || PermissionUtils.hasAccess(MODULE.SALARY, [ACTION.VIEW, ACTION.EDIT]))) {
            return amount;
        } else if (typeof (amount) === "number" && amount != -1 && (!TenantService.get(TENANT.IS_ADMIN) || PermissionUtils.hasAccess(MODULE.SALARY, [ACTION.VIEW, ACTION.EDIT]))) {
            return amount;
        } else if(amount === undefined || amount === null){
            return amount;
        } else {
            return MaskInputUtil.MASK_CHARS;
        }
    }

    static setRolePermissionData(rolePermissionData) {
        if (rolePermissionData?.status === "OK") {
            this.ROLE_PERMISSION = rolePermissionData;
        }
    }

    static getUserRolePermissions() {
        let rolePermissions = [];
        if (this.ROLE_PERMISSION && Array.isArray(this.ROLE_PERMISSION.rolePermissions)) {
            rolePermissions = this.ROLE_PERMISSION.rolePermissions;
        }

        return rolePermissions;
    }

    static getUserSettingsPermissions() {
        let settingsPermissions = [];
        if (this.ROLE_PERMISSION && Array.isArray(this.ROLE_PERMISSION.settingPermissions)) {
            settingsPermissions = this.ROLE_PERMISSION.settingPermissions;
        }

        return settingsPermissions;
    }

    static hasAccessPermissisonForPWUsers(navigation, route) {
        if (navigation) {
            switch (navigation.id) {
                case "SETTINGS":
                    return this.getUserSettingsPermissions().some((item) => item.permission.includes("r"));
                default:
                    return false;
            }
        }

        if (route) {
            switch (route.route) {
                case PAGE_ROUTES.SETTINGS:
                    return this.getUserSettingsPermissions().some((item) => item.permission.includes("r"));
                case PAGE_ROUTES.SEQUENCE_FORMAT:
                    return this.hasPermissionForSettingCard(SETTING_CARD.SEQUENCE_NUMBER_SETTINGS);
                case PAGE_ROUTES.AUDIT_LOGS:
                    return this.hasPermissionForSettingCard(SETTING_CARD.AUDIT_LOGS);
                default:
                    return false;
            }
        }

        return false;
    }

    static hasPermissionForSettingCard(cardId) {
        return this.getUserSettingsPermissions().some((item) => item.id === cardId && item.permission.includes("r"));
    }

    static hasUserRolePermission(role) {
        if (TenantService.get(TENANT.IS_OWNER)) {
            return true;
        }

        let key = role?.key || 'employee';
        if (role?.isDefault && role?.name === 'ADMIN') {
            key = 'sys_admin';
        }

        return this.getUserRolePermissions().some((item) => item.key === key && item.permission.includes("rw"));
    }
}

export default PermissionUtils;
